// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#cx-main {
  transition: all 0.5s;
  padding: 80px 20px 20px 20px;
  background: linear-gradient(120deg, rgba(0, 126, 204, 0.3411764706) 0%, rgba(236, 0, 140, 0.2509803922) 100%);
  min-height: calc(100vh - 60px);
  min-height: 100vh;
  margin-left: 250px;
}

.cx-active {
  margin-left: 60px !important;
  transition: all 0.5s;
}

.cx-header-wrapper.cx-active {
  width: calc(100% - 60px) !important;
  margin-left: 60px !important;
}

.btn-slide {
  background: #00bfb6;
  position: relative;
  /* Right Slider */
}
.btn-slide .btn {
  text-align: center;
  text-transform: uppercase;
  color: #fff;
  font-weight: bold;
  font-size: 16px;
  position: relative;
  z-index: 1;
  transition: all 1s ease;
  width: 200px;
  height: 50px;
  line-height: 50px;
  border: 2px solid #fff;
  margin: 30px 0;
  position: relative;
  cursor: pointer;
  transition: all 1s ease;
  overflow: hidden;
}
.btn-slide .btn:before {
  content: "";
  width: 100%;
  height: 100%;
  background-color: #fff;
  position: absolute;
  transition: all 1s ease;
}
.btn-slide .btn-2:before {
  top: 0;
  left: -210px;
}
.btn-slide .btn-1:before {
  top: 0;
  left: 210px;
}
.btn-slide .btn1-active::before {
  left: 0;
}
.btn-slide .btn2-active::before {
  left: 0;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/style.scss"],"names":[],"mappings":"AAAA;EACE,oBAAA;EACA,4BAAA;EACA,6GAAA;EACE,8BAAA;EACF,iBAAA;EACA,kBAAA;AACF;;AACA;EACE,4BAAA;EACA,oBAAA;AAEF;;AACA;EACE,mCAAA;EACA,4BAAA;AAEF;;AAEA;EACE,mBAAA;EACA,kBAAA;EAmCA,iBAAA;AAjCF;AADE;EACE,kBAAA;EACA,yBAAA;EACA,WAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,UAAA;EACA,uBAAA;EACA,YAAA;EACA,YAAA;EACA,iBAAA;EACA,sBAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,uBAAA;EACA,gBAAA;AAGJ;AAAE;EACE,WAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,uBAAA;AAEJ;AACE;EACE,MAAA;EACA,YAAA;AACJ;AAGE;EACE,MAAA;EACA,WAAA;AADJ;AAiBE;EACE,OAAA;AAfJ;AAiBE;EACE,OAAA;AAfJ","sourcesContent":["#cx-main {\n  transition: all 0.5s;\n  padding: 80px 20px 20px 20px;\n  background: linear-gradient(120deg, #007ecc57 0%, #ec008c40 100%);\n    min-height: calc(100vh - 60px);\n  min-height: 100vh;\n  margin-left: 250px;\n}\n.cx-active {\n  margin-left: 60px !important;\n  transition: all 0.5s;\n\n}\n.cx-header-wrapper.cx-active {\n  width: calc(100% - 60px) !important;\n  margin-left: 60px !important;\n\n}\n\n.btn-slide {\n  background: #00bfb6;\n  position: relative;\n  .btn {\n    text-align: center;\n    text-transform: uppercase;\n    color: #fff;\n    font-weight: bold;\n    font-size: 16px;\n    position: relative;\n    z-index: 1;\n    transition: all 1s ease;\n    width: 200px;\n    height: 50px;\n    line-height: 50px;\n    border: 2px solid #fff;\n    margin: 30px 0;\n    position: relative;\n    cursor: pointer;\n    transition: all 1s ease;\n    overflow: hidden;\n  }\n\n  .btn:before {\n    content: \"\";\n    width: 100%;\n    height: 100%;\n    background-color: #fff;\n    position: absolute;\n    transition: all 1s ease;\n\n  }\n  .btn-2:before {\n    top: 0;\n    left: -210px;\n  }\n\n  /* Right Slider */\n  .btn-1:before {\n    top: 0;\n    left: 210px;\n  }\n\n  // .btn:hover {\n  //   color: #00bfb6 ;\n  // }\n\n  // .btn-2:hover::before,\n  // .btn-1:hover::before {\n  //   left: 0;\n  // }\n\n\n  label {\n  }\n\n  .btn1-active::before {\n    left: 0;\n  }\n  .btn2-active::before {\n    left: 0;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
